import { Component } from '@angular/core';
import { TsAvatar, TsAvatarGroupComponent } from 'tsui/lib/ts-avatar-group/ts-avatar-group.component';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'table-avatar-group-renderer',
  standalone: true,
  imports: [TsAvatarGroupComponent],
  template: `
    <div class="h-full w-full flex flex-row gap-2 justify-start items-center">
      <ts-avatar-group [avatars]="avatars" [maxAvatars]="1"></ts-avatar-group>
      <span>{{ avatars[0]?.name }}</span>
    </div>
  `,
})
export class TableUserRendererComponent implements ICellRendererAngularComp {
  protected avatars: TsAvatar[];

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.avatars = params?.value ? this.convertUserToTsAvatars(params.data) : null;
    return true;
  }

  private convertUserToTsAvatars(user): TsAvatar[] {
    return [
      {
        imageSrc: user?.avatar_url,
        name: user?.user_name,
      },
    ];
  }
}
